import { useQuery } from '@tanstack/react-query';

import { type AccountRelatedListKey, getAccountRelatedList } from '~/services/ContractingService';

import { accountQueryKeys } from './accountQueryKeys';
import { retryUnlessRejected } from './retryUnlessRejected';

export function useGetAccountRelatedList<K extends AccountRelatedListKey>(accountId: string | undefined, list: K) {
  return useQuery({
    queryKey: accountQueryKeys.relatedList(accountId ?? '', list),
    queryFn: ({ signal }) => getAccountRelatedList(accountId ?? '', list, { signal }),
    enabled: !!accountId,
    retry: retryUnlessRejected,
  });
}
